// Update language change from dropdown on header
export function updateLanguage(newLanguage) {
  return {
    type: "UPDATE_LANGUAGE",
    newLanguage
  };
}
